import { QueryClient } from '@tanstack/react-query';

import { apiGetSearchQuery } from '../../api';
import { SEARCH_QUERY_KEYS } from '../../constants';
import { ProductSearchItem, SearchFilters, SearchQueryParams } from '../../model';

type Params = {
    queryKey: string;
    filters?: SearchFilters;
    sort?: SearchQueryParams['sort'];
    limit?: number;
    signal?: AbortSignal;
    clientIp?: string;
};

export const loadProductsCustomQuery = async ({ queryKey, filters, sort, limit, signal, clientIp }: Params) => {
    const searchParams: SearchQueryParams = {
        searchText: '',
        ...(filters ? { filters } : {}),
        ...(sort ? { sort } : {}),
        ...(limit ? { limit } : {}),
    };

    const response = await apiGetSearchQuery<ProductSearchItem>(queryKey, searchParams, signal, clientIp);

    return response.data;
};

export const prefetchProductsCustomQuery = (queryClient: QueryClient, params: Params) => {
    const { queryKey, filters, sort, limit } = params;

    return queryClient.prefetchQuery({
        queryKey: [SEARCH_QUERY_KEYS.SEARCH_RESULTS_PRODUCTS_CUSTOM_QUERY, queryKey, filters, sort, limit],
        queryFn: () => loadProductsCustomQuery(params),
    });
};
